var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyLists(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 8.9999C20.4 9.33127 20.1314 9.5999 19.8 9.5999H12.6C12.2686 9.5999 12 9.33127 12 8.9999V8.9999C12 8.66853 12.2686 8.3999 12.6 8.3999H19.8C20.1314 8.3999 20.4 8.66853 20.4 8.9999V8.9999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 12.6C20.4 12.9314 20.1314 13.2 19.8 13.2H12.6C12.2686 13.2 12 12.9314 12 12.6V12.6C12 12.2686 12.2686 12 12.6 12H19.8C20.1314 12 20.4 12.2686 20.4 12.6V12.6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 16.2001C20.4 16.5315 20.1314 16.8001 19.8 16.8001H12.6C12.2686 16.8001 12 16.5315 12 16.2001V16.2001C12 15.8687 12.2686 15.6001 12.6 15.6001H19.8C20.1314 15.6001 20.4 15.8687 20.4 16.2001V16.2001Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H8.4C8.73137 0 9 0.268629 9 0.6V0.6C9 0.931371 8.73137 1.2 8.4 1.2H1.2V18H5.4V19.2H1C0.447715 19.2 0 18.7523 0 18.2V1Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2002 2.80005C4.2002 2.24776 4.64791 1.80005 5.2002 1.80005H15.6002C15.9316 1.80005 16.2002 2.06868 16.2002 2.40005V2.40005C16.2002 2.73142 15.9316 3.00005 15.6002 3.00005H5.4002V20.4001H8.4002C8.73157 20.4001 9.0002 20.6687 9.0002 21.0001V21.0001C9.0002 21.3314 8.73157 21.6001 8.4002 21.6001H5.2002C4.64791 21.6001 4.2002 21.1523 4.2002 20.6001V2.80005Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3999 5.19995C8.3999 4.64767 8.84762 4.19995 9.3999 4.19995H22.9999C23.5522 4.19995 23.9999 4.64767 23.9999 5.19995V22.3999C23.9999 22.9522 23.5522 23.3999 22.9999 23.3999H9.3999C8.84762 23.3999 8.3999 22.9522 8.3999 22.3999V5.19995ZM9.5999 5.39995V22.1999H22.7999V5.39995H9.5999Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLists);
export default __webpack_public_path__ + "static/media/my-lists.9ee2b7c8ea7c889ae804d109ecc50814.svg";
export { ForwardRef as ReactComponent };